export const PERIOD_ENUM = {
  MONTHS: 'months',
  WEEKS: 'weeks',
  DAYS: 'days'
};

export const DEFAULT_PERIOD = PERIOD_ENUM.MONTHS;
